import { useStaticQuery, graphql } from "gatsby"

export const usePrismCalorexNet = () =>{
const prismic =useStaticQuery(
    graphql`{
      allPrismicCalorexNet {
        edges {
          node {
            uid
            data {
              model_name {
                text,
                html
              }
              color_start {
                text
              }
              color_end {
                text
              }
              claim {
                text
              }
              ideal_copy {
                text
              }
              ideal_list {
                text
              }
              main_image_xs {
                url
                alt
              }
              main_image_sm {
                url
                alt
              }
              main_image_md {
                url
                alt
              }
              main_image_lg {
                url
                alt
              }
              main_image_xlg {
                url
                alt
              }
              calorex_design
              body {
                # __typename
                # ... on PrismicCalorexNetBodyConoceloGrupo {
                #   items {
                #     conocelo_title {
                #       text
                #       html
                #     }
                #     conocelo_description {
                #       text
                #       html
                #     }
                #     conocelo_image {
                #       alt
                #       url
                #       lg {
                #         url
                #       }
                #       sm {
                #         url
                #       }
                #     }
                #     conocelo_x
                #     conocelo_y
                #   }
                # }
                __typename
                ... on PrismicCalorexNetBodySistemas {
                  items {
                    systems_title {
                      html
                      text
                    }
                    systems_description {
                      html
                      text
                    }
                    systems_image {
                      url
                      alt
                      xs {
                        url
                      }
                      sm {
                        url
                      }
                      lg {
                        url
                      }
                    }
                  }
                }
                __typename
                ... on PrismicCalorexNetBodyStorytelling2 {
                  primary {
                    storytelling_title {
                      text
                      html
                    }
                    storytelling_2_description {
                      text
                      html
                    }
                  }
                }
                __typename
                ... on PrismicCalorexNetBodyVentajas {
                  items {
                    advantage_title {
                      html
                      text
                    }
                    advantage_description {
                      html
                      text
                    }
                    advantage_image {
                      url
                      alt
                    }
                    advantage_icon {
                      url
                      alt
                    }
                  }
                }
                __typename
                ... on PrismicCalorexNetBodyYoutube {
                  items {
                    video_url {
                      embed_url
                    }
                    title {
                      text
                    }
                    # description {
                    #   text
                    # }
                  }
                }
                __typename
                ... on PrismicCalorexNetBodyBannerApp {
                  primary {
                    app_image {
                      alt
                      url
                      sm {
                        url
                      }
                      md {
                        url
                      }
                    }
                  }
                  items {
                    link_image {
                      url
                      alt
                    }
                    app_link {
                      text
                    }
                  }
                }
                # __typename
                # ... on PrismicCalorexNetBodyBannerVideo {
                #   primary {
                #     banner_image_xlg {
                #       alt
                #       url
                #     }
                #     banner_image_sm {
                #       alt
                #       url
                #     }
                #     banner_image_xs {
                #       alt
                #       url
                #     }
                #   }
                # }
              }
            }
          }
        }
    }
  }`  );

  return prismic.allPrismicCalorexNet;
}
